import KeeperTeams from './KeeperTeams';

export default KeeperTeams; // Default export - now shows team tiles